import { render, staticRenderFns } from "./kegiatanBimtek.vue?vue&type=template&id=a902ae9e"
import script from "./kegiatanBimtek.vue?vue&type=script&lang=js"
export * from "./kegiatanBimtek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports